/* Accessibility utilities — ported from Shopify Dawn.
   Exposes getFocusableElements / trapFocus / removeTrapFocus / onKeyUpEscape / announceLive globally. */
(function(){
  function getFocusableElements(container){
    return Array.prototype.slice.call(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  var trapFocusHandlers = {};

  function trapFocus(container, elementToFocus){
    elementToFocus = elementToFocus || container;
    var elements = getFocusableElements(container);
    if(!elements.length) return;
    var first = elements[0], last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function(event){
      if(event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function(){
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function(event){
      if(event.code && event.code.toUpperCase() !== 'TAB') return;
      if(event.key && event.key !== 'Tab') return;
      if(event.target === last && !event.shiftKey){ event.preventDefault(); first.focus(); }
      if((event.target === container || event.target === first) && event.shiftKey){
        event.preventDefault(); last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    try{ elementToFocus.focus(); }catch(e){}
  }

  function removeTrapFocus(elementToFocus){
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if(elementToFocus){ try{ elementToFocus.focus(); }catch(e){} }
  }

  function onKeyUpEscape(event){
    if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    if(event.key && event.key !== 'Escape') return;
    var openDetailsElement = event.target.closest && event.target.closest('details[open]');
    if(!openDetailsElement) return;
    var summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    if(summaryElement){
      summaryElement.setAttribute('aria-expanded', 'false');
      summaryElement.focus();
    }
  }

  function announceLive(message){
    if(!message) return;
    var region = document.getElementById('gscdLiveRegion');
    if(!region) return;
    region.textContent = '';
    window.setTimeout(function(){
      region.textContent = message;
    }, 50);
  }

  window.getFocusableElements = getFocusableElements;
  window.trapFocus = trapFocus;
  window.removeTrapFocus = removeTrapFocus;
  window.onKeyUpEscape = onKeyUpEscape;
  window.announceLive = announceLive;
})();
